import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import type { ReactNode } from "react";
import { getPostHogAnalyticsConfig } from "./config";
import { redactSensitiveUrlAndRequestData } from "./sanitize";

let initialized = false;

export function isPostHogAnalyticsEnabled(): boolean {
  return getPostHogAnalyticsConfig().enabled;
}

export function getPostHogClient() {
  return posthog;
}

export function initPostHogAnalytics(): boolean {
  const config = getPostHogAnalyticsConfig();
  if (!config.enabled || !config.token) return false;

  if (!initialized) {
    posthog.init(config.token, {
      api_host: config.apiHost,
      ui_host: config.uiHost,
      defaults: "2026-01-30",
      capture_pageview: false,
      autocapture: false,
      person_profiles: "identified_only",
      disable_session_recording: !config.replayEnabled,
      mask_all_text: false,
      mask_all_element_attributes: true,
      property_denylist: [
        "email",
        "name",
        "prompt",
        "transcript",
        "content",
        "markdown",
        "text",
        "body",
      ],
      session_recording: {
        blockClass: "ph-no-capture",
        blockSelector: ".ph-no-capture",
        maskAllInputs: true,
        maskTextSelector: ".ph-mask-text",
        recordHeaders: false,
        recordBody: false,
        maskCapturedNetworkRequestFn: redactSensitiveUrlAndRequestData,
      },
      loaded: (client) => {
        client.register({
          app: "web_app",
          app_area: "product",
          environment: config.environment,
          release: config.release,
        });
      },
    });
    initialized = true;
  }

  return true;
}

export function PostHogAppProvider({ children }: { children: ReactNode }) {
  if (!initPostHogAnalytics()) {
    return <>{children}</>;
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
